function limparDocumento(doc) {
    return String(doc).replace(/[^\w]/g, '').toUpperCase();
}

/**
 * Validador de CPF (Estritamente numérico)
 */
function validarCPF(cpf) {
    const cleanCPF = limparDocumento(cpf);

    // CPF deve ter 11 dígitos e ser puramente numérico
    if (cleanCPF.length !== 11 || !/^\d+$/.test(cleanCPF)) return false;

    // Elimina CPFs com todos os dígitos iguais (ex: 111.111.111-11)
    if (/^(\d)\1+$/.test(cleanCPF)) return false;

    // Validação do 1º Dígito Verificador
    let soma = 0;
    for (let i = 0; i < 9; i++) {
        soma += parseInt(cleanCPF.charAt(i)) * (10 - i);
    }
    let resto = (soma * 10) % 11;
    let dv1 = resto === 10 || resto === 11 ? 0 : resto;
    if (dv1 !== parseInt(cleanCPF.charAt(9))) return false;

    // Validação do 2º Dígito Verificador
    soma = 0;
    for (let i = 0; i < 10; i++) {
        soma += parseInt(cleanCPF.charAt(i)) * (11 - i);
    }
    resto = (soma * 10) % 11;
    let dv2 = resto === 10 || resto === 11 ? 0 : resto;
    if (dv2 !== parseInt(cleanCPF.charAt(10))) return false;

    return true;
}

/**
 * Validador de CNPJ Alfanumérico (Compatível com formato antigo e novo)
 */
function validarCNPJ(cnpj) {
    const cleanCNPJ = limparDocumento(cnpj);

    // CNPJ deve ter exatamente 14 caracteres
    // Os 12 primeiros podem ser Letras (A-Z) ou Números (0-9). Os 2 últimos DEVEM ser números.
    if (cleanCNPJ.length !== 14 || !/^[A-Z0-9]{12}\d{2}$/.test(cleanCNPJ)) {
        return false;
    }

    // Função auxiliar para converter o caractere segundo a regra oficial (ASCII - 48)
    const obterValorCaractere = (caractere) => {
        return caractere.charCodeAt(0) - 48; // '0' vira 0, 'A' vira 17, 'Z' vira 42...
    };

    // Pesos oficiais do Módulo 11 para o CNPJ
    const pesosDV1 = [5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];
    const pesosDV2 = [6, 5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];

    // Cálculo do 1º Dígito Verificador
    let soma1 = 0;
    for (let i = 0; i < 12; i++) {
        soma1 += obterValorCaractere(cleanCNPJ.charAt(i)) * pesosDV1[i];
    }
    let resto1 = soma1 % 11;
    let dv1 = resto1 < 2 ? 0 : 11 - resto1;
    if (dv1 !== parseInt(cleanCNPJ.charAt(12))) return false;

    // Cálculo do 2º Dígito Verificador
    let soma2 = 0;
    for (let i = 0; i < 13; i++) {
        soma2 += obterValorCaractere(cleanCNPJ.charAt(i)) * pesosDV2[i];
    }
    let resto2 = soma2 % 11;
    let dv2 = resto2 < 2 ? 0 : 11 - resto2;
    if (dv2 !== parseInt(cleanCNPJ.charAt(13))) return false;

    return true;
}

export { validarCNPJ, validarCPF, limparDocumento };
